import { type PointGroup } from 'signature_pad';

import { SignatureFormat } from '../signature-types';

import { decodeDataUrl, encodeDataUrl } from './data-url';

export const encodePoints = (points: PointGroup[]) =>
  encodeDataUrl({
    data: JSON.stringify(points),
    mimeType: SignatureFormat.POINTS,
  });

export const decodePoints = (dataUrl: string): PointGroup[] | null => {
  const decodedDataUrl = decodeDataUrl(dataUrl);
  if (decodedDataUrl?.mimeType === SignatureFormat.POINTS) {
    try {
      const points = JSON.parse(decodedDataUrl.data);
      return points as PointGroup[];
    } catch (e) {
      return null;
    }
  }
  return null;
};
